import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@chargify/custom-ui-components';

import { DetailRow } from '../DetailRow';

export type Props = {
  /**
   * Base price
   */
  basePrice: string;
  /**
   * Cancellation date
   */
  cancellationDate: string;
};

const Canceled = ({ basePrice, cancellationDate }: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);

  return (
    <Box marginTop={5}>
      <DetailRow
        label={{
          value: t('subscription_details.base_price', {
            ns: 'subscriptions-manager',
          }),
          color: 'danger.dark',
        }}
        value={{
          value: basePrice,
          color: 'danger.dark',
          fontWeight: 0,
        }}
      />
      <DetailRow
        label={{
          value: t('subscription_details.cancellation_date', {
            ns: 'subscriptions-manager',
          }),
        }}
        value={{
          value: cancellationDate,
          fontWeight: 3,
        }}
      />
    </Box>
  );
};
export default Canceled;
